import { Chip, colors} from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import { ReactElement } from 'react';
import styles from './Coverage.module.scss';

const cx = classNames.bind(styles);

interface CoverageProp {
  csCoverage: boolean;
  crCoverage: boolean;
  lfiCoverage: boolean;
}

const Coverage = ({ csCoverage, crCoverage, lfiCoverage }: CoverageProp): ReactElement => (

<div className={cx('body')}>
  {csCoverage && (
    <Chip
      short
      label="Research"
      color={colors['research-bg-color']}
      backgroundColor={colors['research-font-color']}
      dataTestId="research-coverage"
    />
  )}
  {crCoverage && (
    <Chip
      short
      label="Covenants"
      color={colors['covenants-font-color']}
      backgroundColor={colors['covenants-bg-color']}
      dataTestId="covenants-coverage"
    />
  )}
  {lfiCoverage && (
    <Chip
      short
      label="News"
      color={colors['news-font-color']}
      backgroundColor={colors['news-bg-color']}
      dataTestId="news-coverage"
    />
  )}
</div>
);

export default Coverage;
